import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import { KeenIcon, FormikStateSelect } from '@/components';

const AdvancedSettingsAddress = ({ data, onConfirm, loadData, loadDataSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  
  const handleCancel = (resetForm) => {
    setIsEditing(false)
    resetForm()
  }
  
    const formFields = {
      country: { label: 'Country' },
      address: { label: 'Address' },
      address_2: { label: 'Address Line 2' },
      city: { label: 'City' },
      state: { label: 'State' },
      zip_postal_code: { label: 'Zip/Postal Code' },
    };
    
    const validationSchema = Yup.object().shape({
      country: Yup.string().required('Country is required'),
      address: Yup.string().required('Address is required'),
      city: Yup.string().required('City is required'),
      zip_postal_code: Yup.string().required('Zip Code is required'),
      firm_email: Yup.string().email('Invalid email').required('Email is required'),
    });
    
    const initialValues = {
      account_owner: data?.account_owner || '',
      legal_business_name: data?.legal_business_name || '',
      country: data?.country || '',
      address: data?.address || '',
      address_2: data?.address_2 || '',
      city: data?.city || '',
      state: data?.state || '',
      zip_postal_code: data?.zip_postal_code || '',
      phone_number: data?.phone_number || '',
      firm_email: data?.firm_email || '',
      website: data?.website || '',
      tax_id: data?.tax_id || '',
      date_format: data?.date_format || '',
      time_format: data?.time_format || '',
      // company_logo: data?.company_logo ? [{ dataURL: data?.company_logo }] : []
      company_logo: data?.company_logo ? data?.company_logo : []
    }
  return (
    <div className="card">
      <div className="card-header" id="advanced_settings_address">
        <h3 className="card-title">Address</h3>
        <button onClick={() => setIsEditing(true)} className="btn btn-xs btn-icon btn-icon-lg link">
          <KeenIcon icon="notepad-edit" className="text-[12px]" />
        </button>
      </div>
      <div className="card-body grid gap-5 lg:py-7.5">
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={(values) => {
              const formData = new FormData();
              const avatarFile = Array.isArray(values.company_logo) && values.company_logo.length > 0
              ? values.company_logo[0].file
              : values.company_logo;
              const finalData = {
                ...initialValues,   // pre-fill everything
                ...values,        // override only what was edited in the form
                // company_logo: values.company_logo,
              };
              Object.entries(finalData).forEach(([key, value]) => {
                formData.append(key, value ?? '');
              });
              
              formData.append('_method', 'PUT');
              for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + pair[1]);
              }
              // return
              onConfirm(formData);
              setIsEditing(false);
            }}
          >
            {({ errors, values, setFieldValue, resetForm }) => (
              <Form>
                <table className="table align-middle text-sm text-gray-500">
                  <tbody>
                    {loadData || loadDataSave ? (
                      <tr>
                        <td colSpan={2} className="text-center py-4">
                          <span>Loading...</span>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {/* <tr>
                          <td className="text-gray-800 font-medium">Firm Info</td>
                          <td></td>
                        </tr> */}

                        {Object.entries(formFields).map(([key, config]) => (
                          <tr key={key}>
                            <td className="py-2 text-gray-600">{config.label}</td>
                            <td className="py-2 text-gray-800">
                            {isEditing ? (
                                  key === 'state' ? (
                                    <FormikStateSelect hideLabel />
                                  ) : (
                                    <>
                                      <Field name={key} value={values[key] ?? ''} className="input input-sm input-bordered w-full" />
                                      <ErrorMessage name={key} component="div" className="text-red-500 text-xs mt-1" />
                                    </>
                                  )
                                ) : (
                                  (() => {
                                    const value = values[key];
                                    if (!value) return '—'; // Show dash for null/undefined/empty

                                    if (key === 'website') {
                                      return <a href={value} target="_blank" rel="noopener noreferrer" className="link">{value}</a>;
                                    } else if (key === 'firm_email') {
                                      return <a href={`mailto:${value}`} rel="noopener noreferrer">{value}</a>;
                                    } else if (key === 'phone_number') {
                                      return <a href={`tel:${value}`} rel="noopener noreferrer">{value}</a>;
                                    } else if (key === 'company_logo') {
                                      return <img src={value} alt="Company Logo" className="w-20 h-20 rounded-full object-contain" />;
                                    } else {
                                      return value;
                                    }
                                  })()
                                )}
                            </td>
                          </tr>
                        ))}
                        {isEditing && (
                          <tr>
                            <td></td>
                            <td className="pt-3">
                              <button
                                type="submit"
                                disabled={loadDataSave}
                                className="btn btn-sm btn-primary"
                              >
                                {loadDataSave ? "Saving..." : "Save"}
                              </button>
                              <button
                                type="button"
                                onClick={() => {handleCancel(resetForm)}}
                                className="btn btn-sm "
                              >
                                Cancel
                              </button>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </Form>
            )}
        </Formik>
      </div>
    </div>
  ) 
};
export { AdvancedSettingsAddress };